import type { MutationTree } from 'vuex';
import type { Alert } from '@getaccept/lib-shared/src/alert/types/alert';
import type { AlertState } from './alert.types';
import { AlertMutation } from './alert.constants';

export const mutations: MutationTree<AlertState> = {
  [AlertMutation.Add](state: AlertState, alert: Alert) {
    state.queue = [...state.queue, alert];
  },
  [AlertMutation.Remove](state: AlertState) {
    state.queue.shift();
  },
};
